import { lazy } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import PageNotFound from "./components/pageNotFound/PageNotFound.jsx";
import "./index.css";
import MainLayout from "./layouts/MainLayout";

// import Main from "./components/main/Main.jsx";
// import Products from "./components/products/Products.jsx";
// import OurClients from "./components/ourClients/OurClients.jsx";
// import Contacts from "./components/contacts/Contacts.jsx";
const Main = lazy(() => import("./components/main/Main.jsx"));
const Products = lazy(() => import("./components/products/Products.jsx"));
const OurClients = lazy(() => import("./components/ourClients/OurClients.jsx"));
const Contacts = lazy(() => import("./components/contacts/Contacts.jsx"));

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<MainLayout />}>
            <Route index element={<Main />} />
            <Route path="products" element={<Products />} />
            <Route path="our-clients" element={<OurClients />} />
            <Route path="contacts" element={<Contacts />} />
          </Route>
          <Route path="/*" element={<PageNotFound />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
